import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { Link } from "react-router-dom";

export type HeadButtonProps = {
    id?: string;
    icon?: typeof SvgIcon;
    iconRight?: boolean;
    title?: string;
    to?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    "data-at_id"?: string;
};

class HeadButton extends React.Component<HeadButtonProps> {
    public domElement: React.RefObject<HTMLButtonElement>;
    constructor(props: HeadButtonProps) {
        super(props);
        this.domElement = React.createRef();
    }
    public rootItem(): React.ReactElement {
        const { icon: Icon, iconRight } = this.props;
        return (
            <button
                className="button_icon_header"
                id={this.props.id}
                ref={this.domElement}
                onClick={this.props.onClick}
                data-at_id={this.props["data-at_id"]}
            >
                {Icon && !iconRight && <Icon htmlColor="white" />}
                {Icon && iconRight && <Icon htmlColor="white" />}
            </button>
        );
    }
    public render(): React.ReactElement {
        if (this.props.to) {
            return (
                <div>
                    <Link id={this.props.id} to={this.props.to}>
                        {this.rootItem()}
                    </Link>
                </div>
            );
        } else {
            return this.rootItem();
        }
    }
}

export { HeadButton };
